module.exports = __webpack_public_path__ + "img/search.944fa476.svg";